// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__91s4E","modal":"ErrorPage_modal__M6lrW","errorMessage":"ErrorPage_errorMessage__ETANQ"};